import { Popover, Transition } from "@headlessui/react";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Auth from "./Model/AuthModel";
// react icons
import { Fragment } from "react";
import { BiLogOutCircle } from "react-icons/bi";
import { FaSearch } from "react-icons/fa";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { decodeToken } from "react-jwt";
import { logoutUser } from "../statemanagement/slice/AuthenticationSlice";
import { NotifyInfo } from "../toastify";
import logo from "./../assets/favicon.ico";
import BottomNav from "./BottomNav";
import Cart from "./cart";
import CollectionIcon from "./icons/CollectionIcon";
import ProductIcon from "./icons/ProductIcon";
import wishListIcon from "./icons/wishListIcon";
import AddProduct from "./Model/addProduct";

export const Header = () => {
  const [IsSignup, setIsSignup] = React.useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("authenticate");
  const isguest = localStorage.getItem("isguest");
  const decodeData = decodeToken(token);
  const handleLogout = () => {
    dispatch(logoutUser({ navigate }));
  };

  let search =
    window.location.pathname === "/" ||
    window.location.pathname.includes("/search");

  if (window.location.pathname.includes("/search")) {
    NotifyInfo("You are on the search page");
  }

  return (
    <>
      <header className="py-3 mb-0 border-b">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center gap-4 md:hidden">
            <PopoverFunction
              IsSignup={IsSignup}
              setIsSignup={setIsSignup}
              token={token}
              isguest={isguest}
              handleLogout={handleLogout}
              decodeData={decodeData}
            />
          </div>
          <Link
            to="/"
            className="
            text-3xl font-bold text-blue-500 hover:text-blue-600 transition duration-400 ease-in-out hover:scale-105 transform m-0 p-0 absolute left-1/2 -translate-x-1/2 md:relative md:left-auto md:transform-none"
          >
            <img src={logo} alt="Logo" className="h-8" />
          </Link>
          <Link
            to={(search ? "" : window.location.pathname) + "/search"}
            className="md:hidden lg:hidden ml-6 text-md font-medium  text-black  bg-white hover:text-gray-600 p-2 rounded px-5 transition duration-400 ease-in-out"
          >
            <FaSearch />
          </Link>
          <nav className="hidden md:flex gap-x-4 mb-3">
            <Link
              to="/"
              className="text-md font-medium  text-black hover:text-gray-600 transition duration-400 ease-in-out"
            >
              Home
            </Link>
            <Link
              to="/collection"
              className="ml-6 text-md font-medium text-black hover:text-gray-600 transition duration-400 ease-in-out"
            >
              Collections
            </Link>
            <Link
              to="/products"
              className="ml-6 text-md font-medium text-black hover:text-gray-600 transition duration-400 ease-in-out"
            >
              Products
            </Link>
            <Link
              to="/wishlist"
              className="ml-6 text-md font-medium  text-black hover:text-gray-600 transition duration-400 ease-in-out"
            >
              Wishlist
            </Link>
          </nav>
          <div className="hidden md:flex items-center gap-6">
            <Link
              to={(search ? "" : window.location.pathname) + "/search"}
              className="ml-6 text-xl font-medium  text-black  bg-white hover:text-gray-600 p-2 rounded px-5 transition duration-400 ease-in-out"
            >
              <FaSearch />
            </Link>
            {isguest === "true" || !token ? (
              <>
                <button
                  className={
                    !IsSignup
                      ? "bg-black hover:bg-[#141414] text-white px-4 py-3 rounded-lg transition duration-400 ease-in-out"
                      : "text-black hover:text-[#1f3f9c] transition duration-400 ease-in-out"
                  }
                  type="button"
                  onClick={() => {
                    setIsSignup(false);
                  }}
                >
                  <Auth
                    IsSignup={IsSignup}
                    setIsSignup={setIsSignup}
                    text={"Log in"}
                  />
                </button>
                <button
                  className={
                    IsSignup
                      ? "bg-black hover:bg-[#1f3f9c] text-white px-4 py-3 rounded-lg transition duration-400 ease-in-out"
                      : "text-black hover:text-[#1f3f9c] transition duration-400 ease-in-out"
                  }
                  type="button"
                  onClick={() => {
                    setIsSignup(true);
                  }}
                >
                  <Auth
                    IsSignup={IsSignup}
                    setIsSignup={setIsSignup}
                    text={"Sign up"}
                  />
                </button>
                <Cart />
              </>
            ) : (
              <>
                {decodeData?.role === true && <AddProduct />}
                <Cart />
                <p
                  className="bg-black hover:bg-[#1f3f9c] fixed right-0 bottom-0 mr-7 mb-7 z-50 rounded-full p-2 text-white text-2xl cursor-pointer hover:scale-110 hover:animate-pulse transition-transform duration-300 ease-in-out"
                  type="button"
                  onClick={handleLogout}
                >
                  <BiLogOutCircle title="Logout" />
                </p>
              </>
            )}
          </div>
        </div>
      </header>
      <BottomNav />
    </>
  );
};

const Options = [
  {
    name: "Products",
    description: "Discover the best products for your needs.",
    href: "/products",
    icon: ProductIcon,
  },
  {
    name: "Collections",
    description: "Get our specific collection of shoes.",
    href: "/wishlist",
    icon: CollectionIcon,
  },
  {
    name: "Wishlist",
    description: "Create your own collection of shoes.",
    href: "/wishlist",
    icon: wishListIcon,
  },
];

export default function PopoverFunction({
  IsSignup,
  setIsSignup,
  handleLogout,
  token,
  isguest,
  decodeData,
}) {
  const [open, setOpen] = React.useState(false);
  function openModalDropDown() {
    setOpen(!open);
  }
  function closeModalDropDown() {
    setOpen(false);
  }
  return (
    <Popover className="relative">
      <>
        <Popover.Button
          onClick={openModalDropDown}
          className={`text-opacity-100 group inline-flex items-center text-base font-medium text-white hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 px-4 py-3 rounded-lg transition duration-400 ease-in-out cursor-pointer`}
        >
          <HiOutlineMenuAlt1
            className={`${
              open ? "transform rotate-180" : "transform rotate-0"
            } ml-2 h-5 w-5 text-black transition duration-150 ease-in-out group-hover:text-opacity-80`}
            aria-hidden="true"
          />
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 -translate-y-1/4"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-1/4"
          show={open}
        >
          <Popover.Panel
            className="absolute left-0 top-0 z-20 mt-14 max-w-sm w-72 transform px-4 sm:px-0 lg:max-w-3xl"
            onClose={closeModalDropDown}
          >
            <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="relative grid gap-6 bg-white p-6">
                {Options.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="-m-3 flex items-center rounded-lg p-2 mb-auto transition duration-150 ease-in-out hover:bg-gray-300 bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-blue-600 focus-visible:ring-opacity-50"
                    onClick={closeModalDropDown}
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12">
                      <item.icon aria-hidden="true" />
                    </div>
                    <div className="ml-4">
                      <p className="text-sm font-medium text-black">
                        {item.name}
                      </p>
                      <p className="text-sm text-gray-500">
                        {item.description}
                      </p>
                    </div>
                  </Link>
                ))}
                {isguest === "true" || !token ? (
                  <div className="flex items-center justify-between">
                    <button
                      className={
                        !IsSignup
                          ? "bg-white hover:bg-black hover:text-white text-black px-4 py-3 rounded-lg transition duration-400 ease-in-out"
                          : "bg-white hover:bg-black hover:text-white text-black px-4 py-3 rounded-lg transition duration-400 ease-in-out"
                      }
                      type="button"
                      onClick={() => {
                        setIsSignup(false);
                      }}
                    >
                      <Auth
                        IsSignup={IsSignup}
                        setIsSignup={setIsSignup}
                        text={"Log in"}
                        closeModalDropDown={closeModalDropDown}
                      />
                    </button>
                    <button
                      className={
                        IsSignup
                          ? "bg-white hover:bg-black hover:text-white text-black px-4 py-3 rounded-lg transition duration-400 ease-in-out"
                          : "bg-white hover:bg-black hover:text-white text-black px-4 py-3 rounded-lg transition duration-400 ease-in-out"
                      }
                      type="button"
                      onClick={() => {
                        setIsSignup(true);
                      }}
                    >
                      <Auth
                        IsSignup={IsSignup}
                        setIsSignup={setIsSignup}
                        text={"Sign up"}
                        closeModalDropDown={closeModalDropDown}
                      />
                    </button>
                  </div>
                ) : (
                  <div className="flex items-center justify-around">
                    <Cart />
                    {decodeData?.role === true && <AddProduct />}
                    <button
                      className="bg-black hover:bg-gray-500 rounded-full p-2 text-white text-2xl cursor-pointer hover:scale-110 hover:animate-pulse transition-transform duration-300 ease-in-out"
                      type="button"
                      onClick={handleLogout}
                    >
                      <BiLogOutCircle title="Logout" />
                    </button>
                  </div>
                )}
              </div>
              <div className="bg-gray-50 p-2">
                <a
                  href="##"
                  className="flow-root rounded-md px-3 py-0 transition duration-150 ease-in-out hover:bg-black-100 focus:outline-none focus-visible:ring focus-visible:ring-blue-600 focus-visible:ring-opacity-50"
                >
                  <span className="flex items-center">
                    <span className="text-sm font-medium text-black">
                      Tips & Tricks
                    </span>
                  </span>
                  <span className="block text-sm text-gray-500">
                    You can add products to your wishlist by clicking on the
                    heart icon
                  </span>
                </a>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </>
    </Popover>
  );
}
